import React from 'react'
import AddEditBrand from '../../../../Components/AddEditBrand/AddEditBrand'

const createBrand = () => {
  return (
    <div>
        <div className="row align-items-center justify-content-between mb-4">
            <div className="col">
                <h5 className="fw-500 text-white mb-0">Create Brand</h5>
            </div>
        </div>
        <div className="card mb-4">
            <div className="card-body">
                <AddEditBrand/>
            </div>
        </div>
    </div>
  )
}

export default createBrand